import {axiosService} from "../axios.service";
import {urls} from "../../constants";


const sampleMenuService = {
    getAll: () => axiosService.get(urls.menu.sampleMenu)
        .then(value => value.data),
    addSampleMenuDishes: (data) => axiosService.post(urls.menu.sampleMenuDishes, data).then((value) => value.data),
    updateSampleMenuDishes: (id, data)=> axiosService.patch(`${urls.menu.sampleMenuDishes}/${id}`, data).then((value) => value.data),
}

export {
    sampleMenuService
}